import { render, staticRenderFns } from "./CourtJuvenile.vue?vue&type=template&id=f4ae9eb4&scoped=true&"
import script from "./CourtJuvenile.vue?vue&type=script&lang=js&"
export * from "./CourtJuvenile.vue?vue&type=script&lang=js&"
import style0 from "./CourtJuvenile.vue?vue&type=style&index=0&id=f4ae9eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ae9eb4",
  null
  
)

export default component.exports